import { NavLink } from 'react-router-dom';
import { IconChart } from '../../components/ui/icons';

const tiles = [
  {
    to: '/custodian/reports/inventory',
    title: 'Custody inventory',
    body: 'State and inventory mix across facilities, SPVs, and asset populations.',
    chip: 'Inventory',
  },
  {
    to: '/custodian/reports/movement',
    title: 'Custody movement',
    body: 'Lifecycle actions: pledges, releases, transfers, and repository motion.',
    chip: 'Movement',
  },
  {
    to: '/custodian/reports/certification-receipts',
    title: 'Certification & receipts',
    body: 'Certificates issued, deliveries, reissues, and receipt throughput.',
    chip: 'Certs',
  },
  {
    to: '/custodian/reports/turnaround-sla',
    title: 'Turnaround & SLA',
    body: 'Queue aging, maker-checker latency, and SLA attainment by queue.',
    chip: 'SLA',
  },
];

export function CustodianReportsHubPage() {
  return (
    <div className="page-stack">
      <div className="card-shell p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-evault bg-evault-select-bg text-evault-teal ring-1 ring-evault-select-ring/50">
            <IconChart className="h-4 w-4" />
          </span>
          <div className="min-w-0">
            <h2 className="text-sm font-semibold text-umb-neutral-dark">
              Custodian report modules
            </h2>
            <p className="mt-1 text-xs leading-relaxed text-umb-neutral-dark/60">
              Tiles navigate only. Run, Schedule, and Export live in each report
              dashboard header — same pattern as originator and provider.
            </p>
          </div>
        </div>
      </div>

      <ul className="grid gap-3 sm:grid-cols-2">
        {tiles.map((tile, i) => (
          <li key={tile.to}>
            <NavLink
              to={tile.to}
              className="group card-shell relative block h-full rounded-evault p-4 transition-colors hover:border-evault-teal/30 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-evault-teal/30 focus-visible:ring-offset-2"
            >
              <span className="absolute right-3 top-3 text-2xl font-bold tabular-nums text-umb-neutral-mid/30">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="inline-block rounded bg-umb-neutral-light px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-umb-primary ring-1 ring-umb-primary/10">
                {tile.chip}
              </span>
              <h3 className="mt-2 pr-10 text-sm font-semibold text-umb-neutral-dark group-hover:text-evault-teal">
                {tile.title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-evault-muted">
                {tile.body}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-evault-teal">
                Open dashboard →
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
